import React from 'react';
import { IValueAgentChipRow } from './interface';
import { ValueRow } from '../ValueRow';
import { Stack } from '@mui/material';
import { AgentBadge } from '../../AgentBadge';

export const ValueAgentsChipRow: React.FC<IValueAgentChipRow> = ({
  label,
  agents,
  width = '50px',
}): JSX.Element => {
  return (
    <ValueRow label={label} width={width}>
      {agents?.length ? (
        <Stack direction="row" gap="5px">
          {agents.map((agent, index) => (
            <AgentBadge agent={agent} key={index} />
          ))}
        </Stack>
      ) : (
        '-'
      )}
    </ValueRow>
  );
};
